import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { injectQuery, queryOptions } from '@ngneat/query';
import { TranslateModule } from '@ngx-translate/core';
import { SonaSpinnerComponent } from '@sona/angular-ui-components';
import { SonaGeneralLayout } from '@sona/angular-ui-layouts';
import { useLanguage, useQuery, useTitle, injectTranslation } from '@sona/angular-util-common';

@Component({
    selector: 'sona-privacy',
    imports: [
        TranslateModule,
        SonaGeneralLayout,
        SonaSpinnerComponent
    ],
    templateUrl: './privacy.page.html',
    styleUrl: './privacy.page.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'c-sona-privacy-page'
    }
})
export class PrivacyPage {
    private readonly _httpClient = inject(HttpClient);
    private readonly _query = injectQuery();
    private readonly language = useLanguage();

    readonly content = useQuery(this.language, (language) =>
        queryOptions({
            queryKey: [ 'privacy-policy', language ] as const,
            queryFn: () =>
                this._httpClient.get(
                    `https://privacy.cookiebox.pro/privacy?id=AypJoVUnnPAsuqFBYebe&lang=${language}&script=false`,
                    {
                        responseType: 'text'
                    }
                )
        })
    ).result;

    constructor() {
        useTitle(injectTranslation('PAGE.PRIVACY.TITLE'));
    }
}
